import {useState} from "react"
import {Button} from "primereact/button"
import {InputText} from "primereact/inputtext"
import {Divider} from "primereact/divider"
import {v4 as uuid} from "uuid"
import api from "../../api"
import commonStyles from "../common.module.css"
import styles from "./styles.module.css"
import confirmation from "../../function/confirmation"

export default function FileList({files, onChange, entityUrl, isDisabled}) {
  const [content, setContent] = useState("")
  const [name, setName] = useState("")
  const handleNameChange = (e) => setName(e.target.value)
  const [note, setNote] = useState("")
  const handleNoteChange = (e) => setNote(e.target.value)

  const [editFileUuid, setEditFileUuid] = useState("")
  const editFile = (file) => {
    setEditFileUuid(file.uuid)
    setName(file.name)
    setNote(file.note)
  }

  const onFileSelect = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0]
      const reader = new FileReader()
      setName(file.name)
      reader.onload = () => setContent(reader.result)
      reader.readAsDataURL(file)
    }
  }

  const addFile = () => {
    onChange([...files, {uuid: uuid(), name, note, content}])
    setName("")
    setNote("")
    setContent("")
  }

  const addFileAsync = () => {
    api.put(`${entityUrl}/file`, {name, note, content})
      .then(() => {
        onChange()
        setName("")
        setNote("")
        setContent("")
      })
  }

  const editFileAsync = () => {
    api.post(`${entityUrl}/file/${editFileUuid}`, {uuid: editFileUuid, name, note})
      .then(() => {
        onChange()
        setEditFileUuid("")
        setName("")
        setNote("")
        setContent("")
      })
  }

  const removeFile = (uuid) => onChange(files.filter((file) => file.uuid !== uuid))

  const removeFileAsync = (fileUuid) => {
    api.delete(`${entityUrl}/file/${fileUuid}`)
      .then(onChange)
  }

  const removeFileConfirmation = (target, fileUuid) => confirmation(target,
    "Opravdu smazat?",
    () => entityUrl ? removeFileAsync(fileUuid) : removeFile(fileUuid))

  const submit = (e) => {
    e.preventDefault()
    editFileUuid
      ? editFileAsync()
      : entityUrl
        ? addFileAsync()
        : addFile()
  }

  return (
    <>
      <Divider className={"mt-0"}>Přílohy</Divider>

      {files.length === 0 && (
        <div className={`${commonStyles.emptyMessage} font-italic`}>Žádné přílohy</div>
      )}

      {files.map((file) => (
        <div key={file.uuid} className={`${styles.file} py-1 pl-2`}>
          <div className={"flex"}>
            {file.url
              ? <a href={file.url} className={"text-primary underline"} target={"_blank"}
                   rel={"noreferrer"}>{file.name}</a>
              : <span className={"text-primary"}>{file.name}</span>}

            <div className={"ml-auto"}>
              {entityUrl && <Button className={"p-button-text p-0"} icon={"pi pi-pencil"}
                                    onClick={() => editFile(file)}/>}
              <Button className={"p-button-text p-button-danger p-0"} icon={"pi pi-times"}
                      onClick={(e) => removeFileConfirmation(e.target, file.uuid)}/>
            </div>
          </div>

          <div className={"text-"}>{file.note}</div>
          {file.mimeType && file.size && (
            <div className={"text-xs text-400"}>
              ({file.mimeType}, {(file.size / 1000).toFixed(2)} kB)
            </div>
          )}
        </div>
      ))}

      <Divider className={"font-normal"}>Nová příloha</Divider>

      <form onSubmit={submit}>
        <div className={"p-fluid"}>
          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Soubor:</label>
            <div className={"p-inputgroup"}>
              <InputText placeholder={"Název"} value={name} onChange={handleNameChange}/>

              <label className={"p-inputgroup-addon"}>
                Nahrát soubor
                <input type={"file"} onChange={onFileSelect} className={"hidden"}
                       disabled={isDisabled}/>
              </label>
            </div>
          </div>

          <div className={"field"}>
            <label>Popis:</label>
            <InputText placeholder={"Popis"} value={note}
                       onChange={handleNoteChange}/>
          </div>
        </div>

        <div className={"flex"}>
          {editFileUuid
            ? <Button type={"submit"} label={"Aktualizovat přílohu"} className={"ml-auto"}
                      disabled={!name}/>
            : <Button type={"submit"} label={"Přidat přílohu"} className={"ml-auto"}
                      disabled={!name || !content}/>
          }
        </div>
      </form>
    </>
  )
}
